import React from 'react';
import S from './YourSolutionCta.styles';
const YourSolutionCta = ({ yspVisible, setYSPVisible }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { "aria-label": "Your Solution", onClick: () => setYSPVisible(!yspVisible) },
            React.createElement(S.Logo, { role: "img" }))));
};
export default YourSolutionCta;
